module.exports = __webpack_public_path__ + "img/about-page-icon-travel.785f7af9.svg";